import HierarchicalPositionsV2 from "./HierarchicalPositionsV2";

function PositionsContainerV2() {
    return <HierarchicalPositionsV2 />;
}

export default PositionsContainerV2;
